<template>
	<div class="topic-manager">
		<div class="row" style="margin-bottom: 20px;">
			<div class="col-xl-6">评审专家</div>
			<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
		</div>
		<el-card>
			<el-form :inline="true" ref="expertFormRef" :model="expertForm" label-width="80px">
				<el-form-item label="姓名"><el-input v-model="expertForm.name"></el-input></el-form-item>
				<!-- <el-form-item label="单位"><el-input v-model="expertForm.name"></el-input></el-form-item> -->
				<el-form-item><el-button type="primary" @click="searchExpert">查询</el-button></el-form-item>
			</el-form>
			<el-table  :header-cell-style="tableHeaderStyle" border ref="expertTableRef" :data="expertList" tooltip-effect="dark" style="width: 100%" @selection-change="multipleSelect">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="realName" label="姓名"></el-table-column>
				<el-table-column prop="username" label="用户名"></el-table-column>
				<el-table-column prop="unitName" label="单位"></el-table-column>
			</el-table>
			 <el-pagination
						style="text-align: center;margin-top: 10px;"
			      @size-change="expertSizeChange"
			      @current-change="expertCurrentChange"
			      :current-page="expertForm.pageNumber"
			      :page-sizes="[10, 50]"
			      :page-size="expertForm.pageSize"
			      layout="total, sizes, prev, pager, next, jumper"
			      :total="total">
			    </el-pagination>
			<div class="btn-wrap">
				<el-button type="primary" @click="openUserDialog">添加</el-button>
				<el-button type="danger" @click="delExpert">删除</el-button>
			</div>
		</el-card>
		<!-- 用户列表 -->
		<el-dialog title="添加评审专家" :visible.sync="userListDialogVisible" width="80%" :close-on-click-modal="false">
			<el-form :inline="true" ref="userFormRef" :model="userForm" label-width="80px">
				<el-form-item label="姓名"><el-input v-model="userForm.realName"></el-input></el-form-item>
				<el-form-item label="单位"><el-input v-model="userForm.unitName"></el-input></el-form-item>
				<el-form-item><el-button type="primary" @click="searchUser">查询</el-button></el-form-item>
			</el-form>
			<el-table border ref="userTableRef" :data="userList" tooltip-effect="dark" style="width: 100%" @selection-change="userMultipleSelect">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="realName" label="姓名"></el-table-column>
				<el-table-column prop="username" label="用户名"></el-table-column>
				<el-table-column prop="unitName" label="单位"></el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="scope">
						{{scope.row.status == 1? '可用':'禁用'}}
					</template>
				</el-table-column>
				<el-table-column prop="roleNames" label="角色">
					<template slot-scope="scope">
						{{scope.row.roleNames.join('、')}}
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
						style="text-align: center;margin-top: 10px;"
			     @size-change="userSizeChange"
			     @current-change="userCurrentChange"
			     :current-page="userForm.pageNumber"
			     :page-sizes="[10, 50]"
			     :page-size="userForm.pageSize"
			     layout="total, sizes, prev, pager, next, jumper"
			     :total="userTotal">
			   </el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="userListDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addExpert">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { getListByRoleId, getUserList, updateRole } from '@/api/after/systemManagement';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
      		tableHeaderStyle: { backgroundColor: "#3083c5", color: "#fff"},
			expertList: [],
			userList: [],
			userTotal: 0,
			total: 0,
			multipleSelection: [],
			userMultipleVal: [],
			expertForm: {
				pageNumber: 1,
				pageSize: 10,
				roleId: 3,
				name:''
			},
			userForm: {
				pageNumber: 1,
				pageSize: 10,
				realName: '',
				unitName: '',
				roleId:3,//排除已经是专家的用户
			},
			userListDialogVisible: false
		};
	},
	created() {
		this.getListByRoleId(this.expertForm);
	},
	methods: {
		// 获取专家列表
		async getListByRoleId(form) {
			const res = await getListByRoleId(form);
			if (res.code == 200) {
				this.expertList = res.data.records;
				this.total = res.data.total;
			} else {
				this.$message.error(res.data);
			}
		},
		// 获取用户列表
		async getUserList() {
			const res = await getUserList(this.userForm);
			if (res.code == 200) {
				this.userList = res.data.records;
				this.userTotal = res.data.total;
			} else {
				this.$message.error(res.data);
			}
		},
		// 打开用户对话框
		openUserDialog(){
			this.userListDialogVisible = true
			this.getUserList()
		},
		// 添加或者删除专家角色
		async updateRole(data){
			const res = await updateRole(data)
			if (res.code == 200) {
				this.userMultipleVal = []
				this.multipleSelection = []
				this.userListDialogVisible = false
				this.expertForm.pageNumber = 1
				this.getListByRoleId(this.expertForm)
			}else{
				this.$message.error(res.data)
			}
		},
		// 搜索专家
		searchExpert(){
			this.expertForm.pageNumber = 1
			this.getListByRoleId(this.expertForm);
		},
		// 搜索用户
		searchUser(){
			this.userForm.pageNumber = 1
			this.getUserList()
		},
		// 添加专家
		addExpert(){
			let params = this.userMultipleVal.map(item=>{
				let curRoleId = item.roleId?item.roleId.split(','):[]
				curRoleId.push(3)
				return {
					id:item.id,
					roleId:curRoleId.join(',')
				}
			})
			this.updateRole(params)
		},
		// 删除专家
		delExpert(){
			let params = this.multipleSelection.map(item=>{
				let curRoleId = item.roleId?item.roleId.split(','):[]
				let expertIdIndex = curRoleId.findIndex(item1=>{
					return item1==3
				})
				curRoleId.splice(expertIdIndex,1)
				return {
					id:item.id,
					roleId:curRoleId.join(',')
				}
			})
			this.updateRole(params)
		},
		// 多选
		multipleSelect(val) {
			this.multipleSelection = val;
		},
		expertSizeChange(val){
			this.expertForm.pageSize = val
		},
		expertCurrentChange(val){
			this.expertForm.pageNumber = val
		},
		userSizeChange(val){
			this.userForm.pageSize = val
		},
		userCurrentChange(val){
			this.user.pageNumber = val
		},
		userMultipleSelect(val) {
			this.userMultipleVal = val;
		}
	}
};
</script>

<style scoped lang="scss">
.btn-wrap {
	margin-top: 20px;
}
</style>
